/**
 * Centralised ad manager.
 *
 * Templates only supply three empty containers -- #topContainer,
 * #bottomAdsContainer and #rightAdsContainer -- plus the targeting globals
 * collected from the post's Ghost tags (allTag, internalTagInhouse,
 * internalTagSponsor) and viewerType. This file decides what goes in them:
 *
 *   ad blocker detected -> house ads pulled from Airtable, injected as images
 *   otherwise           -> Google Ad Manager slots defined and displayed
 *
 * Loaded through {{#contentFor "ads-container"}} so it runs after the
 * containers and their globals exist.
 */
(function () {
  var COMMUNITY = 'CMOA';
  // GAM's ad units for this community drop the trailing A: CMO, not CMOA.
  var GAM_AD_UNIT_PREFIX = 'CMO';
  var GAM_NETWORK = '23035269294';
  var AIRTABLE_BASE = 'appmEWAUnRlSWtQP2';
  var MEDIA_PACK_URL = '/media-pack/?filter=digital---advertising';

  var HOST_AIRTABLE = typeof host_1 !== 'undefined' && host_1 ? host_1 : 'https://middleware.pmmalliance.com';
  var HOST_AD_MANAGER = typeof host_2 !== 'undefined' && host_2 ? host_2 : 'https://middleware-v2.pmmalliance.com';

  var SLOTS = [
    {unit: 'top-banner', size: [728, 90], container: 'topContainer'},
    {unit: 'mobile-top', size: [300, 100], container: 'topContainer'},
    {unit: 'bottom-banner', size: [580, 400], container: 'bottomAdsContainer'},
    {unit: 'mobile-bottom', size: [240, 400], container: 'bottomAdsContainer'},
    {unit: 'side-banner', size: [240, 400], container: 'rightAdsContainer'}
  ];

  /* ------------------------------------------------------------------ *
   * Reading the template globals
   *
   * Templates declare these with `let`, which puts them in the global
   * declarative scope rather than on `window`, and not every template
   * declares all of them. So each read goes through a try/catch: an
   * undeclared identifier throws ReferenceError, which we treat as absent.
   * ------------------------------------------------------------------ */

  function readGlobal(reader) {
    try {
      return reader();
    } catch (err) {
      return undefined;
    }
  }

  function readGlobalArray(reader) {
    var value = readGlobal(reader);
    return Array.isArray(value) ? value : [];
  }

  function getViewerType() {
    var value = readGlobal(function () { return viewerType; });
    return normaliseViewerType(value || window.viewerType);
  }

  // Templates have historically written the tier both as "Exec+" and as
  // "exec-plus"; the ad tags always use the slug form.
  function normaliseViewerType(value) {
    var slug = String(value || 'outsider').toLowerCase().trim();
    if (slug === 'exec+' || slug === 'exec plus') {
      return 'exec-plus';
    }
    if (slug === 'pro+' || slug === 'pro plus') {
      return 'pro-plus';
    }
    return slug;
  }

  // ...while the Airtable "Tier type" column uses the display form.
  function viewerTypeLabel(slug) {
    switch (slug) {
      case 'insider': return 'Insider';
      case 'pro': return 'Pro';
      case 'pro-plus': return 'Pro+';
      case 'exec-plus': return 'Exec+';
      default: return 'Outsider';
    }
  }

  /* ------------------------------------------------------------------ *
   * Shared helpers
   * ------------------------------------------------------------------ */

  function hasAnyContainer() {
    return SLOTS.some(function (slot) {
      return document.getElementById(slot.container);
    });
  }

  function generateRandomAdSlotId() {
    return 'div-gpt-ad-' + Date.now() + Math.floor(Math.random() * 10000) + '-0';
  }

  function appendMediaPackLink(element) {
    var link = document.createElement('a');
    link.classList.add('media-pack');
    link.setAttribute('href', MEDIA_PACK_URL);
    link.textContent = 'Advertise with us';
    element.insertAdjacentElement('afterend', link);
  }

  function pickRandom(array) {
    return array[Math.floor(Math.random() * array.length)];
  }

  /* ------------------------------------------------------------------ *
   * Ad blocker detection
   * ------------------------------------------------------------------ */

  function checkAdsBlocked(callback) {
    fetch('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', {
      method: 'HEAD',
      mode: 'no-cors'
    })
      .then(function (response) {
        // The URL doesn't redirect, so a redirect means a blocker intercepted it.
        callback(response.redirected);
      })
      .catch(function () {
        // Any failure counts as blocked; connection problems are not considered.
        callback(true);
      });
  }

  /* ------------------------------------------------------------------ *
   * Blocked: house ads from Airtable
   * ------------------------------------------------------------------ */

  function getBlockAds() {
    var url = HOST_AIRTABLE + '/airtable-retrieve-custom-table' +
      '?attr=Grid%20view&view=' + COMMUNITY + '&base=' + AIRTABLE_BASE;

    fetch(url)
      .then(function (response) { return response.json(); })
      .then(renderHouseAds)
      .catch(function (err) { console.error(err); });
  }

  function renderHouseAds(ads) {
    var byPosition = {top: [], right: [], bottom: []};
    var tierLabel = viewerTypeLabel(getViewerType());
    var publicTags = readGlobalArray(function () { return allTag; });

    (Array.isArray(ads) ? ads : []).forEach(function (ad) {
      var fields = ad && ad.fields;
      if (!fields || fields['Status'] !== 'Active') {
        return;
      }

      var position = String(fields['Position'] || '').toLowerCase();
      if (!byPosition[position]) {
        return;
      }

      var adTags = fields['Tag'];
      if (adTags && adTags.length > 0) {
        var matchesTag = adTags.some(function (tag) { return publicTags.indexOf(tag) !== -1; });
        if (!matchesTag) {
          return;
        }
      }

      var tiers = fields['Tier type'];
      if (tiers && tiers.length > 0 && tiers.indexOf(tierLabel) === -1) {
        return;
      }

      byPosition[position].push(ad);
    });

    displayHouseAd(pickRandom(byPosition.top), document.getElementById('topContainer'));
    displayHouseAd(pickRandom(byPosition.right), document.getElementById('rightAdsContainer'));
    displayHouseAd(pickRandom(byPosition.bottom), document.getElementById('bottomAdsContainer'));
  }

  function createImgLinkElement(ad) {
    var link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.href = ad.fields['Link'];

    var attachments = window.innerWidth <= 500
      ? ad.fields['Mobile image']
      : ad.fields['Desktop image'];

    var img = document.createElement('img');
    img.src = attachments && attachments.length ? attachments[attachments.length - 1].url : '';
    img.alt = ad.fields['Name'];

    link.appendChild(img);
    return link;
  }

  function displayHouseAd(ad, container) {
    if (!ad || !container) {
      return;
    }

    var link = createImgLinkElement(ad);
    container.appendChild(link);
    container.style.display = 'block';
    appendMediaPackLink(link);
  }

  /* ------------------------------------------------------------------ *
   * Not blocked: Google Ad Manager
   * ------------------------------------------------------------------ */

  function fetchAd() {
    var suffix = '-' + getViewerType();
    var tags = readGlobalArray(function () { return internalTagInhouse; })
      .concat(readGlobalArray(function () { return internalTagSponsor; }))
      .filter(function (tag) { return tag; })
      .map(function (tag) { return tag + suffix; });

    tags.push('global' + suffix);

    // The middleware expects the community slug lowercased; the GAM targeting
    // keys keep COMMUNITY as-is, and the ad unit path uses GAM_AD_UNIT_PREFIX.
    var url = HOST_AD_MANAGER + '/ad-manager/ads' +
      '?community=' + COMMUNITY.toLowerCase() + '&sponsored=false&tags=' + encodeURIComponent(tags.join(','));

    fetch(url)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var foundTags = (data && data.data) || [];
        var placements = SLOTS.map(function (slot) {
          return {slot: slot, id: generateRandomAdSlotId()};
        });

        setupAdManager(placements, foundTags);
        placements.forEach(function (placement) {
          createAdContainer(placement.id, placement.slot.container);
        });

        // GAM needs a moment to decide whether each slot actually filled.
        setTimeout(function () {
          placements.forEach(function (placement) { addMediaPackLink(placement.id); });
        }, 2000);
      })
      .catch(function (err) { console.error('Error:', err); });
  }

  // gpt.js publishes window.googletag; this stands in until it has loaded.
  function gpt() {
    window.googletag = window.googletag || {cmd: []};
    return window.googletag;
  }

  function setupAdManager(placements, foundTags) {
    var googletag = gpt();
    googletag.cmd.push(function () {
      placements.forEach(function (placement) {
        googletag
          .defineSlot(
            '/' + GAM_NETWORK + '/' + GAM_AD_UNIT_PREFIX + '-Sponsor-and-Inhouse/' + placement.slot.unit,
            placement.slot.size,
            placement.id
          )
          .addService(googletag.pubads());
      });
      googletag.pubads().enableSingleRequest();
      googletag.pubads().collapseEmptyDivs();
      googletag.pubads()
        .setTargeting(COMMUNITY + '-Sponsor-Clients', foundTags)
        .setTargeting(COMMUNITY + '-In-house', foundTags);
      googletag.enableServices();
    });
  }

  function createAdContainer(slotId, containerId) {
    var container = document.getElementById(containerId);
    if (!container) {
      return;
    }

    var adDiv = document.createElement('div');
    adDiv.id = slotId;
    container.appendChild(adDiv);

    var googletag = gpt();
    googletag.cmd.push(function () { googletag.display(slotId); });
  }

  function addMediaPackLink(slotId) {
    var adElem = document.getElementById(slotId);
    if (adElem && window.getComputedStyle(adElem).display !== 'none') {
      appendMediaPackLink(adElem);
    }
  }

  /* ------------------------------------------------------------------ */

  // `gads` is an opt-out other templates can set before this file loads.
  if (hasAnyContainer() && (typeof gads === 'undefined' || gads === true)) {
    checkAdsBlocked(function (adsBlocked) {
      if (adsBlocked) {
        getBlockAds();
      } else {
        fetchAd();
      }
    });
  }
})();
